import { makeAutoObservable } from 'mobx';
import Department from 'main/stores/departments/Department';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';

class DepartmentState {
  store;

  departments;
  editingDepartment = {};
  errors = {};
  editDepartmentModalOpen = false;

  constructor(store) {
    makeAutoObservable(this, {
      store: false
    });

    this.store = store;
  }

  async load() {
    this.departments = await this.store.loadDepartments();
  }

  async saveDepartment() {
    const {model, errors} = this.editingDepartment.isNew
      ? await this.store.postDepartment(this.editingDepartment)
      : await this.store.patch(this.editingDepartment);
    this.errors = errors;

    if (model) {
      await this.load();
      this.closeEditDepartmentModal();
      successAlert(t('company_settings.departments.alerts.Department information saved.'));
    }
  }

  closeEditDepartmentModal() {
    this.editDepartmentModalOpen = false;
  }

  openEditDepartmentModal(department) {
    this.editDepartmentModalOpen = true;
    this.editingDepartment = new Department(department);
  }

  addDepartment() {
    this.openEditDepartmentModal(new Department());
  }

  async removeDepartment(department) {
    await this.store.destroy(department);
    await this.load();
    successAlert(t('company_settings.departments.alerts.Department deleted successfully.'));
  }
}

export default DepartmentState;
